// This file is auto-generated. Do not edit manually.
// Run "npm run -w packages/iconik-api generate" to regenerate.
/** biome-ignore-all lint/complexity/noBannedTypes: some API definitions are unclear */
import { httpMethod } from '../constants';
import type { IconikApiHeaders } from '../types';

export const AclsHttpPostAcl = 'AclsHttpPostAcl' as const;
export const AclsHttpGetAclTemplates = 'AclsHttpGetAclTemplates' as const;
export const AclsHttpPostAclTemplates = 'AclsHttpPostAclTemplates' as const;
export const AclsHttpDeleteAclTemplatesByTemplateId =
  'AclsHttpDeleteAclTemplatesByTemplateId' as const;
export const AclsHttpGetAclTemplatesByTemplateId =
  'AclsHttpGetAclTemplatesByTemplateId' as const;
export const AclsHttpPatchAclTemplatesByTemplateId =
  'AclsHttpPatchAclTemplatesByTemplateId' as const;
export const AclsHttpPutAclTemplatesByTemplateId =
  'AclsHttpPutAclTemplatesByTemplateId' as const;
export const AclsHttpPostAclTemplatesByTemplateIdByObjectTypeByObjectKey =
  'AclsHttpPostAclTemplatesByTemplateIdByObjectTypeByObjectKey' as const;
export const AclsHttpDeleteAclByObjectType =
  'AclsHttpDeleteAclByObjectType' as const;
export const AclsHttpPutAclByObjectType = 'AclsHttpPutAclByObjectType' as const;
export const AclsHttpPutAclByObjectTypeBulk =
  'AclsHttpPutAclByObjectTypeBulk' as const;
export const AclsHttpDeleteAclByObjectTypeContent =
  'AclsHttpDeleteAclByObjectTypeContent' as const;
export const AclsHttpPutAclByObjectTypeContent =
  'AclsHttpPutAclByObjectTypeContent' as const;
export const AclsHttpGetAclByObjectTypeByObjectKey =
  'AclsHttpGetAclByObjectTypeByObjectKey' as const;
export const AclsHttpGetAclByObjectTypeByObjectKeyPermissions =
  'AclsHttpGetAclByObjectTypeByObjectKeyPermissions' as const;
export const AclsHttpGetAclByObjectTypeByObjectKeyByPermission =
  'AclsHttpGetAclByObjectTypeByObjectKeyByPermission' as const;
export const AclsHttpPostAclByObjectTypeByPermission =
  'AclsHttpPostAclByObjectTypeByPermission' as const;
export const AclsHttpDeleteGroupsByGroupIdAclByObjectTypeByObjectKey =
  'AclsHttpDeleteGroupsByGroupIdAclByObjectTypeByObjectKey' as const;
export const AclsHttpGetGroupsByGroupIdAclByObjectTypeByObjectKey =
  'AclsHttpGetGroupsByGroupIdAclByObjectTypeByObjectKey' as const;
export const AclsHttpPutGroupsByGroupIdAclByObjectTypeByObjectKey =
  'AclsHttpPutGroupsByGroupIdAclByObjectTypeByObjectKey' as const;
export const AclsHttpGetGroupsByGroupIdAclByObjectTypeByObjectKeyByPermission =
  'AclsHttpGetGroupsByGroupIdAclByObjectTypeByObjectKeyByPermission' as const;
export const AclsHttpGetSharesByObjectTypeByObjectKey =
  'AclsHttpGetSharesByObjectTypeByObjectKey' as const;
export const AclsHttpPutSharesByShareIdAclByObjectType =
  'AclsHttpPutSharesByShareIdAclByObjectType' as const;
export const AclsHttpDeleteSharesByShareIdAclByObjectTypeByObjectKey =
  'AclsHttpDeleteSharesByShareIdAclByObjectTypeByObjectKey' as const;
export const AclsHttpGetSharesByShareIdAclByObjectTypeByObjectKey =
  'AclsHttpGetSharesByShareIdAclByObjectTypeByObjectKey' as const;
export const AclsHttpPostSharesByShareIdAclByObjectTypeByObjectKey =
  'AclsHttpPostSharesByShareIdAclByObjectTypeByObjectKey' as const;
export const AclsHttpPutSharesByShareIdAclByObjectTypeByObjectKey =
  'AclsHttpPutSharesByShareIdAclByObjectTypeByObjectKey' as const;
export const AclsHttpGetSharesByShareIdAclByObjectTypeByObjectKeyByPermission =
  'AclsHttpGetSharesByShareIdAclByObjectTypeByObjectKeyByPermission' as const;
export const AclsHttpDeleteUsersByUserIdAclByObjectTypeByObjectKey =
  'AclsHttpDeleteUsersByUserIdAclByObjectTypeByObjectKey' as const;
export const AclsHttpGetUsersByUserIdAclByObjectTypeByObjectKey =
  'AclsHttpGetUsersByUserIdAclByObjectTypeByObjectKey' as const;
export const AclsHttpPutUsersByUserIdAclByObjectTypeByObjectKey =
  'AclsHttpPutUsersByUserIdAclByObjectTypeByObjectKey' as const;
export const AclsHttpGetUsersByUserIdAclByObjectTypeByObjectKeyByPermission =
  'AclsHttpGetUsersByUserIdAclByObjectTypeByObjectKeyByPermission' as const;

/**
 * Original schema `ACLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-ACLSchema}
 */
export interface AclsACLSchema {
  groups_acl?: AclsGroupACLBase[];
  inherited_groups_acl?: AclsPropagatingGroupACL[];
  inherited_users_acl?: AclsPropagatingACL[];
  propagating_groups_acl?: AclsPropagatingGroupACL[];
  propagating_users_acl?: AclsPropagatingACL[];
  users_acl?: AclsUserACLBase[];
}
/**
 * Original schema `GroupACLBase`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-GroupACLBase}
 */
export interface AclsGroupACLBase {
  group_id?: string;
  permissions: string[];
}
/**
 * Original schema `PropagatingGroupACL`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-PropagatingGroupACL}
 */
export interface AclsPropagatingGroupACL {
  group_id?: string;
  object_key?: string;
  object_type?: string;
  permissions: string[];
}
/**
 * Original schema `PropagatingACL`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-PropagatingACL}
 */
export interface AclsPropagatingACL {
  object_key?: string;
  object_type?: string;
  permissions: string[];
  user_id?: string;
}
/**
 * Original schema `UserACLBase`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-UserACLBase}
 */
export interface AclsUserACLBase {
  permissions: string[];
  user_id?: string;
}
/**
 * Original schema `ACLTemplateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-ACLTemplateSchema}
 */
export interface AclsACLTemplateSchema {
  date_created?: string;
  date_modified?: string;
  id?: string;
  name: string;
}
/**
 * Original schema `ACLTemplatesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-ACLTemplatesSchema}
 */
export interface AclsACLTemplatesSchema {
  objects?: AclsACLTemplateSchema[];
}
/**
 * Original schema `ACLsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-ACLsSchema}
 */
export interface AclsACLsSchema {
  /**
   * The number of object_keys in the list is limited to a minimum of 0 and a maximum of 500
   *
   * @minItems 0
   * @maxItems 500
   */
  object_keys?: string[];
}
/**
 * Original schema `BulkACLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-BulkACLSchema}
 */
export interface AclsBulkACLSchema {
  access_denied?: string[];
  access_granted?: string[];
}
/**
 * Original schema `BulkACLsObjectSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-BulkACLsObjectSchema}
 */
export interface AclsBulkACLsObjectSchema {
  object_keys: string[];
  object_type: string;
  permissions: ('read' | 'write' | 'delete' | 'change-acl')[];
}
/**
 * Original schema `BulkCreateShareACLs`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-BulkCreateShareACLs}
 */
export interface AclsBulkCreateShareACLs {
  permissions: string[];
  share_ids: string[];
}
/**
 * Original schema `BulkDeleteShareACLs`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-BulkDeleteShareACLs}
 */
export interface AclsBulkDeleteShareACLs {
  share_ids: string[];
}
/**
 * Original schema `CheckBulkACLsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-CheckBulkACLsSchema}
 */
export interface AclsCheckBulkACLsSchema {
  /**
   * The number of objects in the list is limited to a minimum of 0 and a maximum of 500
   *
   * @minItems 0
   * @maxItems 500
   */
  objects: AclsBulkACLsObjectSchema[];
}
/**
 * Original schema `CombinedPermissionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-CombinedPermissionsSchema}
 */
export interface AclsCombinedPermissionsSchema {
  permissions?: string[];
}
/**
 * Original schema `CopyInheritedACLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-CopyInheritedACLSchema}
 */
export interface AclsCopyInheritedACLSchema {
  date_created?: string;
  date_modified?: string;
  from_collection_ids: string[];
  object_key: string;
  object_type: string;
}
/**
 * Original schema `CreateACLsResultSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-CreateACLsResultSchema}
 */
export interface AclsCreateACLsResultSchema {
  updated_object_keys?: string[];
}
/**
 * Original schema `CreateACLsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-CreateACLsSchema}
 */
export interface AclsCreateACLsSchema {
  group_ids?: string[];
  mode?: 'APPEND' | 'OVERWRITE';
  /**
   * The number of object_keys in the list is limited to a minimum of 0 and a maximum of 500
   *
   * @minItems 0
   * @maxItems 500
   */
  object_keys: string[];
  object_type?: string;
  permissions: string[];
  user_ids?: string[];
}
/**
 * Original schema `CreateACLsSchemaMultiple`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-CreateACLsSchemaMultiple}
 */
export interface AclsCreateACLsSchemaMultiple {
  group_ids?: string[];
  mode?: 'APPEND' | 'OVERWRITE';
  /**
   * The number of object_keys in the list is limited to a minimum of 1 and a maximum of 1
   *
   * @minItems 1
   * @maxItems 1
   */
  object_keys: string[];
  object_type?: string;
  permissions: string[];
  user_ids?: string[];
}
/**
 * Original schema `CreateBulkACLsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-CreateBulkACLsSchema}
 */
export interface AclsCreateBulkACLsSchema {
  group_ids?: string[];
  include_assets: boolean;
  include_collections: boolean;
  mode?: 'APPEND' | 'OVERWRITE';
  /**
   * The number of object_ids in the list is limited to a minimum of 0 and a maximum of 500
   *
   * @minItems 0
   * @maxItems 500
   */
  object_ids?: string[];
  object_type?: string;
  permissions: string[];
  user_ids?: string[];
}
/**
 * Original schema `CreateMultipleACLsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-CreateMultipleACLsSchema}
 */
export interface AclsCreateMultipleACLsSchema {
  /**
   * The number of objects in the list is limited to a minimum of 1 and a maximum of 100
   *
   * @minItems 1
   * @maxItems 100
   */
  objects: AclsCreateACLsSchemaMultiple[];
}
/**
 * Original schema `CreateShareACLsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-CreateShareACLsSchema}
 */
export interface AclsCreateShareACLsSchema {
  /**
   * The number of object_keys in the list is limited to a min of 0 and a maximum of 500
   *
   * @minItems 0
   * @maxItems 500
   */
  object_keys?: string[];
  object_type?: string;
  permissions: string[];
  share_id?: string;
}
/**
 * Original schema `DeleteACLsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-DeleteACLsSchema}
 */
export interface AclsDeleteACLsSchema {
  group_ids?: string[];
  /**
   * The number of object_keys in the list is limitedto a minimum of 0 and a maximum of 500
   *
   * @minItems 0
   * @maxItems 500
   */
  object_keys?: string[];
  object_type?: string;
  user_ids?: string[];
}
/**
 * Original schema `DeleteBulkACLsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-DeleteBulkACLsSchema}
 */
export interface AclsDeleteBulkACLsSchema {
  group_ids?: string[];
  include_assets: boolean;
  include_collections: boolean;
  /**
   * The number of object_ids in the list is limited to a minimum of 0 and a maximum of 500
   *
   * @minItems 0
   * @maxItems 500
   */
  object_ids?: string[];
  object_type?: string;
  user_ids?: string[];
}
/**
 * Original schema `GroupACLBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-GroupACLBaseSchema}
 */
export interface AclsGroupACLBaseSchema {
  group_id?: string;
  permissions: string[];
}
/**
 * Original schema `GroupACLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-GroupACLSchema}
 */
export interface AclsGroupACLSchema {
  date_created?: string;
  date_modified?: string;
  group_id?: string;
  object_key?: string;
  object_type?: string;
  permissions: string[];
}
/**
 * Original schema `GroupIDsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-GroupIDsSchema}
 */
export interface AclsGroupIDsSchema {
  group_ids?: string[];
}
/**
 * Original schema `InheritedACLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-InheritedACLSchema}
 */
export interface AclsInheritedACLSchema {
  collection_ids: string[];
  date_created?: string;
  date_modified?: string;
  object_key?: string;
  object_type?: string;
}
/**
 * Original schema `ListObjectsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-ListObjectsSchema}
 */
export interface AclsListObjectsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `PropagatingACLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-PropagatingACLSchema}
 */
export interface AclsPropagatingACLSchema {
  object_key?: string;
  object_type?: string;
  permissions: string[];
  user_id?: string;
}
/**
 * Original schema `PropagatingGroupACLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-PropagatingGroupACLSchema}
 */
export interface AclsPropagatingGroupACLSchema {
  group_id?: string;
  object_key?: string;
  object_type?: string;
  permissions: string[];
}
/**
 * Original schema `ReindexPropagatingACLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-ReindexPropagatingACLSchema}
 */
export interface AclsReindexPropagatingACLSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ShareACLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-ShareACLSchema}
 */
export interface AclsShareACLSchema {
  date_created?: string;
  date_modified?: string;
  object_key?: string;
  object_type?: string;
  permissions: string[];
  share_id?: string;
}
/**
 * Original schema `SharesACLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-SharesACLSchema}
 */
export interface AclsSharesACLSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AclsShareACLSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `UserACLBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-UserACLBaseSchema}
 */
export interface AclsUserACLBaseSchema {
  permissions: string[];
  user_id?: string;
}
/**
 * Original schema `UserACLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-UserACLSchema}
 */
export interface AclsUserACLSchema {
  date_created?: string;
  date_modified?: string;
  object_key?: string;
  object_type?: string;
  permissions: string[];
  user_id?: string;
}
/**
 * Original schema `UserIDsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-UserIDsSchema}
 */
export interface AclsUserIDsSchema {
  user_ids?: string[];
}
/**
 * Original schema `UsersCheckAclSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-UsersCheckAclSchema}
 */
export interface AclsUsersCheckAclSchema {
  group_ids?: string[];
  user_id?: string;
}
/**
 * Original schema `UsersSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-UsersSchema}
 */
export interface AclsUsersSchema {
  users?: AclsUsersCheckAclSchema[];
}
/**
 * Original schema `ACLTemplatesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-ACLTemplatesSchema}
 */
export interface AclsACLTemplatesSchemaWithId {
  objects: AclsACLTemplateSchemaWithIdNullable[];
}
/**
 * Original schema `ACLTemplateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-ACLTemplateSchema}
 */
export interface AclsACLTemplateSchemaWithIdNullable {
  date_created?: string | null;
  date_modified?: string | null;
  id: string;
  name: string;
}
/**
 * Original schema `ACLTemplateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-ACLTemplateSchema}
 */
export interface AclsACLTemplateSchemaWithId {
  date_created?: string;
  date_modified?: string;
  id: string;
  name: string;
}
/**
 * Original schema `ACLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-ACLSchema}
 */
export interface AclsACLSchemaNullable {
  groups_acl?: AclsGroupACLBase[] | null;
  inherited_groups_acl?: AclsPropagatingGroupACL[] | null;
  inherited_users_acl?: AclsPropagatingACL[] | null;
  propagating_groups_acl?: AclsPropagatingGroupACL[] | null;
  propagating_users_acl?: AclsPropagatingACL[] | null;
  users_acl?: AclsUserACLBase[] | null;
}
/**
 * Original schema `CombinedPermissionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-CombinedPermissionsSchema}
 */
export interface AclsCombinedPermissionsSchemaNullable {
  permissions?: string[] | null;
}
/**
 * Original schema `GroupACLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-GroupACLSchema}
 */
export interface AclsGroupACLSchemaNullable {
  date_created?: string | null;
  date_modified?: string | null;
  group_id?: string | null;
  object_key?: string | null;
  object_type?: string | null;
  permissions: string[];
}
/**
 * Original schema `SharesACLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-SharesACLSchema}
 */
export interface AclsSharesACLSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: AclsShareACLSchemaNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `ShareACLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-ShareACLSchema}
 */
export interface AclsShareACLSchemaNullable {
  date_created?: string | null;
  date_modified?: string | null;
  object_key?: string | null;
  object_type?: string | null;
  permissions: string[];
  share_id?: string | null;
}
/**
 * Original schema `UserACLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#model-UserACLSchema}
 */
export interface AclsUserACLSchemaNullable {
  date_created?: string | null;
  date_modified?: string | null;
  object_key?: string | null;
  object_type?: string | null;
  permissions: string[];
  user_id?: string | null;
}

/**
 * `POST /v1/acl/`
 *
 * Check if objects have required permission
 *
 * Required roles:
 *  - can_read_acls
 *
 * Responses
 * - 200 - Returns a dict with two lists `access_granted` and `access_denied` object keys
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - User doesn't have permission
 *
 * Response {@link AclsBulkACLSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/post_v1_acl_}
 */
export const httpPostAcl = (
  body: AclsCheckBulkACLsSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpPostAcl,
  method: httpMethod.post,
  url: '/API/acls/v1/acl/',

  body,
  headers,
});

/**
 * `GET /v1/acl/templates/`
 *
 * Retrieve all acl templates
 *
 * Required roles:
 *  - can_read_acl_templates
 *
 * Responses
 * - 200 - Success
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AclsACLTemplatesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/get_v1_acl_templates_}
 */
export const httpGetAclTemplates = (headers?: IconikApiHeaders) => ({
  id: AclsHttpGetAclTemplates,
  method: httpMethod.get,
  url: '/API/acls/v1/acl/templates/',

  headers,
});

/**
 * `POST /v1/acl/templates/`
 *
 * Create an acl template
 *
 * Required roles:
 *  - can_write_acl_templates
 *
 * Responses
 * - 201 - Successfully Created
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AclsACLTemplateSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/post_v1_acl_templates_}
 */
export const httpPostAclTemplates = (
  body: AclsACLTemplateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpPostAclTemplates,
  method: httpMethod.post,
  url: '/API/acls/v1/acl/templates/',

  body,
  headers,
});

/**
 * `DELETE /v1/acl/templates/{template_id}/`
 *
 * Remove an acl template
 *
 * Required roles:
 *  - can_delete_acl_templates
 *
 * Responses
 * - 204 - Successfully deleted
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - ACL template does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/delete_v1_acl_templates__template_id__}
 */
export const httpDeleteAclTemplatesByTemplateId = (
  templateId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpDeleteAclTemplatesByTemplateId,
  method: httpMethod.delete,
  url: `/API/acls/v1/acl/templates/${encodeURIComponent(templateId)}/`,
  params: { templateId },
  headers,
});

/**
 * `GET /v1/acl/templates/{template_id}/`
 *
 * Retrieve an acl template
 *
 * Required roles:
 *  - can_read_acl_templates
 *
 * Responses
 * - 200 - Success
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Template does not exist
 *
 * Response {@link AclsACLTemplateSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/get_v1_acl_templates__template_id__}
 */
export const httpGetAclTemplatesByTemplateId = (
  templateId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpGetAclTemplatesByTemplateId,
  method: httpMethod.get,
  url: `/API/acls/v1/acl/templates/${encodeURIComponent(templateId)}/`,
  params: { templateId },
  headers,
});

export type AclsACLTemplateSchemaPartial = Partial<AclsACLTemplateSchema>;

/**
 * `PATCH /v1/acl/templates/{template_id}/`
 *
 * Update an acl template
 *
 * Required roles:
 *  - can_write_acl_templates
 *
 * Responses
 * - 200 - Successfully updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - ACL template does not exist
 *
 * Response {@link AclsACLTemplateSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/patch_v1_acl_templates__template_id__}
 */
export const httpPatchAclTemplatesByTemplateId = (
  templateId: string,
  body: AclsACLTemplateSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpPatchAclTemplatesByTemplateId,
  method: httpMethod.patch,
  url: `/API/acls/v1/acl/templates/${encodeURIComponent(templateId)}/`,
  params: { templateId },
  body,
  headers,
});

/**
 * `PUT /v1/acl/templates/{template_id}/`
 *
 * Update an acl template
 *
 * Required roles:
 *  - can_write_acl_templates
 *
 * Responses
 * - 200 - Successfully updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - ACL template does not exist
 *
 * Response {@link AclsACLTemplateSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/put_v1_acl_templates__template_id__}
 */
export const httpPutAclTemplatesByTemplateId = (
  templateId: string,
  body: AclsACLTemplateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpPutAclTemplatesByTemplateId,
  method: httpMethod.put,
  url: `/API/acls/v1/acl/templates/${encodeURIComponent(templateId)}/`,
  params: { templateId },
  body,
  headers,
});

export interface AclsHttpPostAclTemplatesByTemplateIdByObjectTypeByObjectKeyQuery {
  ignore_reindexing?: boolean;
  /**
   * Do not apply any ACLs that are not in the collection_id provided (Parent collection normally)
   */
  restrict_acls_collection_id?: string;
}

/**
 * `POST /v1/acl/templates/{template_id}/{object_type}/{object_key}/`
 *
 * Apply template permissions to an object
 *
 *
 * Responses
 * - 200 - Success
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - User does not have permission
 * - 404 - ACL template does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/post_v1_acl_templates__template_id___object_type___object_key__}
 */
export const httpPostAclTemplatesByTemplateIdByObjectTypeByObjectKey = (
  templateId: string,
  objectType: string,
  objectKey: string,
  query?: AclsHttpPostAclTemplatesByTemplateIdByObjectTypeByObjectKeyQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpPostAclTemplatesByTemplateIdByObjectTypeByObjectKey,
  method: httpMethod.post,
  url: `/API/acls/v1/acl/templates/${encodeURIComponent(templateId)}/${encodeURIComponent(objectType)}/${encodeURIComponent(objectKey)}/`,
  params: { templateId, objectType, objectKey },
  query,
  headers,
});

export interface AclsHttpDeleteAclByObjectTypeQuery {
  /**
   * Do not trigger search reindexing of the affected objects
   */
  ignore_reindexing?: boolean;
}

/**
 * `DELETE /v1/acl/{object_type}/`
 *
 * Delete acls for multiple objects
 *
 * Required roles:
 *  - can_delete_acls
 *
 * Responses
 * - 200 - Returns the deleted objects
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/delete_v1_acl__object_type__}
 */
export const httpDeleteAclByObjectType = (
  objectType: string,
  body: AclsDeleteACLsSchema,
  query?: AclsHttpDeleteAclByObjectTypeQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpDeleteAclByObjectType,
  method: httpMethod.delete,
  url: `/API/acls/v1/acl/${encodeURIComponent(objectType)}/`,
  params: { objectType },
  body,
  query,
  headers,
});

export interface AclsHttpPutAclByObjectTypeQuery {
  /**
   * Do not trigger search reindexing of the affected objects
   */
  ignore_reindexing?: boolean;
}

/**
 * `PUT /v1/acl/{object_type}/`
 *
 * Create a new acl for multiple objects
 *
 * Required roles:
 *  - can_write_acls
 *
 * Responses
 * - 200 - Returns the updated objects
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - User does not have permission to write ACL templates
 *
 * Response {@link AclsCreateACLsResultSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/put_v1_acl__object_type__}
 */
export const httpPutAclByObjectType = (
  objectType: string,
  body: AclsCreateACLsSchema,
  query?: AclsHttpPutAclByObjectTypeQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpPutAclByObjectType,
  method: httpMethod.put,
  url: `/API/acls/v1/acl/${encodeURIComponent(objectType)}/`,
  params: { objectType },
  body,
  query,
  headers,
});

/**
 * Returns the updated objects
 */
export type AclsHttpPutAclByObjectTypeBulkResponse =
  AclsCreateACLsResultSchema[];

export interface AclsHttpPutAclByObjectTypeBulkQuery {
  /**
   * Do not trigger search reindexing of the affected objects
   */
  ignore_reindexing?: boolean;
}

/**
 * `PUT /v1/acl/{object_type}/bulk/`
 *
 * Create a new acl for multiple objects with multiple permissions
 *
 * Required roles:
 *  - can_write_acls
 *
 * Responses
 * - 200 - Returns the updated objects
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AclsHttpPutAclByObjectTypeBulkResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/put_v1_acl__object_type__bulk_}
 */
export const httpPutAclByObjectTypeBulk = (
  objectType: string,
  body: AclsCreateMultipleACLsSchema,
  query?: AclsHttpPutAclByObjectTypeBulkQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpPutAclByObjectTypeBulk,
  method: httpMethod.put,
  url: `/API/acls/v1/acl/${encodeURIComponent(objectType)}/bulk/`,
  params: { objectType },
  body,
  query,
  headers,
});

export interface AclsHttpDeleteAclByObjectTypeContentQuery {
  /**
   * Do not trigger search reindexing of the affected objects
   */
  ignore_reindexing?: boolean;
}

/**
 * `DELETE /v1/acl/{object_type}/content/`
 *
 * Delete acls for content of multiple objects
 *
 * Required roles:
 *  - can_delete_acls
 *
 * Responses
 * - 202 - ACL delete job was started
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 501 - Invalid object type
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/delete_v1_acl__object_type__content_}
 */
export const httpDeleteAclByObjectTypeContent = (
  objectType: string,
  body: AclsDeleteBulkACLsSchema,
  query?: AclsHttpDeleteAclByObjectTypeContentQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpDeleteAclByObjectTypeContent,
  method: httpMethod.delete,
  url: `/API/acls/v1/acl/${encodeURIComponent(objectType)}/content/`,
  params: { objectType },
  body,
  query,
  headers,
});

export interface AclsHttpPutAclByObjectTypeContentQuery {
  /**
   * Do not trigger search reindexing of the affected objects
   */
  ignore_reindexing?: boolean;
}

/**
 * `PUT /v1/acl/{object_type}/content/`
 *
 * Create a new acl for content of multiple objects
 *
 * Required roles:
 *  - can_write_acls
 *
 * Responses
 * - 202 - ACL update job was started
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 501 - Invalid object type
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/put_v1_acl__object_type__content_}
 */
export const httpPutAclByObjectTypeContent = (
  objectType: string,
  body: AclsCreateBulkACLsSchema,
  query?: AclsHttpPutAclByObjectTypeContentQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpPutAclByObjectTypeContent,
  method: httpMethod.put,
  url: `/API/acls/v1/acl/${encodeURIComponent(objectType)}/content/`,
  params: { objectType },
  body,
  query,
  headers,
});

export interface AclsHttpGetAclByObjectTypeByObjectKeyQuery {
  /**
   * Don't return the deleted users/groups
   */
  exclude_deleted?: boolean;
}

/**
 * `GET /v1/acl/{object_type}/{object_key}/`
 *
 * List of object permissions
 *
 * Required roles:
 *  - can_read_acls
 *
 * Responses
 * - 200 - Returns a list of permissions
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AclsACLSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/get_v1_acl__object_type___object_key__}
 */
export const httpGetAclByObjectTypeByObjectKey = (
  objectType: string,
  objectKey: string,
  query?: AclsHttpGetAclByObjectTypeByObjectKeyQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpGetAclByObjectTypeByObjectKey,
  method: httpMethod.get,
  url: `/API/acls/v1/acl/${encodeURIComponent(objectType)}/${encodeURIComponent(objectKey)}/`,
  params: { objectType, objectKey },
  query,
  headers,
});

/**
 * `GET /v1/acl/{object_type}/{object_key}/permissions/`
 *
 * List of permissions for the user
 *
 *
 * Responses
 * - 200 - Returns a list of permissions
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AclsCombinedPermissionsSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/get_v1_acl__object_type___object_key__permissions_}
 */
export const httpGetAclByObjectTypeByObjectKeyPermissions = (
  objectType: string,
  objectKey: string,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpGetAclByObjectTypeByObjectKeyPermissions,
  method: httpMethod.get,
  url: `/API/acls/v1/acl/${encodeURIComponent(objectType)}/${encodeURIComponent(objectKey)}/permissions/`,
  params: { objectType, objectKey },
  headers,
});

/**
 * `GET /v1/acl/{object_type}/{object_key}/{permission}/`
 *
 * Check if particular object has required permission
 *
 * Required roles:
 *  - can_read_acls
 *
 * Responses
 * - 200 - Returns empty dict if object has permission
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Returns empty dict if object doesn't have permission
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/get_v1_acl__object_type___object_key___permission__}
 */
export const httpGetAclByObjectTypeByObjectKeyByPermission = (
  objectType: string,
  objectKey: string,
  permission: string,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpGetAclByObjectTypeByObjectKeyByPermission,
  method: httpMethod.get,
  url: `/API/acls/v1/acl/${encodeURIComponent(objectType)}/${encodeURIComponent(objectKey)}/${encodeURIComponent(permission)}/`,
  params: { objectType, objectKey, permission },
  headers,
});

/**
 * `POST /v1/acl/{object_type}/{permission}/`
 *
 * Check if objects have required permission
 *
 * Required roles:
 *  - can_read_acls
 *
 * Responses
 * - 200 - Returns a dict with two lists `access_granted` and `access_denied` object keys
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - User doesn't have permission
 *
 * Response {@link AclsBulkACLSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/post_v1_acl__object_type___permission__}
 */
export const httpPostAclByObjectTypeByPermission = (
  objectType: string,
  permission: string,
  body: AclsACLsSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpPostAclByObjectTypeByPermission,
  method: httpMethod.post,
  url: `/API/acls/v1/acl/${encodeURIComponent(objectType)}/${encodeURIComponent(permission)}/`,
  params: { objectType, permission },
  body,
  headers,
});

export interface AclsHttpDeleteGroupsByGroupIdAclByObjectTypeByObjectKeyQuery {
  /**
   * Do not trigger search reindexing of the affected objects
   */
  ignore_reindexing?: boolean;
}

/**
 * `DELETE /v1/groups/{group_id}/acl/{object_type}/{object_key}/`
 *
 * Delete a group acl for an object
 *
 * Required roles:
 *  - can_delete_acls
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - ACL does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/delete_v1_groups__group_id__acl__object_type___object_key__}
 */
export const httpDeleteGroupsByGroupIdAclByObjectTypeByObjectKey = (
  groupId: string,
  objectType: string,
  objectKey: string,
  query?: AclsHttpDeleteGroupsByGroupIdAclByObjectTypeByObjectKeyQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpDeleteGroupsByGroupIdAclByObjectTypeByObjectKey,
  method: httpMethod.delete,
  url: `/API/acls/v1/groups/${encodeURIComponent(groupId)}/acl/${encodeURIComponent(objectType)}/${encodeURIComponent(objectKey)}/`,
  params: { groupId, objectType, objectKey },
  query,
  headers,
});

/**
 * `GET /v1/groups/{group_id}/acl/{object_type}/{object_key}/`
 *
 * List of groups permissions for an object
 *
 * Required roles:
 *  - can_read_acls
 *
 * Responses
 * - 200 - Returns a list of group permissions
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Group doesn't have permissions
 *
 * Response {@link AclsGroupACLSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/get_v1_groups__group_id__acl__object_type___object_key__}
 */
export const httpGetGroupsByGroupIdAclByObjectTypeByObjectKey = (
  groupId: string,
  objectType: string,
  objectKey: string,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpGetGroupsByGroupIdAclByObjectTypeByObjectKey,
  method: httpMethod.get,
  url: `/API/acls/v1/groups/${encodeURIComponent(groupId)}/acl/${encodeURIComponent(objectType)}/${encodeURIComponent(objectKey)}/`,
  params: { groupId, objectType, objectKey },
  headers,
});

export interface AclsHttpPutGroupsByGroupIdAclByObjectTypeByObjectKeyQuery {
  /**
   * Do not trigger search reindexing of the affected objects
   */
  ignore_reindexing?: boolean;
}

/**
 * `PUT /v1/groups/{group_id}/acl/{object_type}/{object_key}/`
 *
 * Update or create group acl for an object
 *
 * Required roles:
 *  - can_write_acls
 *
 * Responses
 * - 200 - Returns an updated acl
 * - 201 - Returns a created acl
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - ACL does not exist
 *
 * Response {@link AclsGroupACLSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/put_v1_groups__group_id__acl__object_type___object_key__}
 */
export const httpPutGroupsByGroupIdAclByObjectTypeByObjectKey = (
  groupId: string,
  objectType: string,
  objectKey: string,
  body: AclsGroupACLSchema,
  query?: AclsHttpPutGroupsByGroupIdAclByObjectTypeByObjectKeyQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpPutGroupsByGroupIdAclByObjectTypeByObjectKey,
  method: httpMethod.put,
  url: `/API/acls/v1/groups/${encodeURIComponent(groupId)}/acl/${encodeURIComponent(objectType)}/${encodeURIComponent(objectKey)}/`,
  params: { groupId, objectType, objectKey },
  body,
  query,
  headers,
});

/**
 * `GET /v1/groups/{group_id}/acl/{object_type}/{object_key}/{permission}/`
 *
 * Check if group has particular permission for an object
 *
 * Required roles:
 *  - can_read_acls
 *
 * Responses
 * - 200 - Returns an empty JSON object
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Group doesn't have particular permission
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/get_v1_groups__group_id__acl__object_type___object_key___permission__}
 */
export const httpGetGroupsByGroupIdAclByObjectTypeByObjectKeyByPermission = (
  groupId: string,
  objectType: string,
  objectKey: string,
  permission: string,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpGetGroupsByGroupIdAclByObjectTypeByObjectKeyByPermission,
  method: httpMethod.get,
  url: `/API/acls/v1/groups/${encodeURIComponent(groupId)}/acl/${encodeURIComponent(objectType)}/${encodeURIComponent(objectKey)}/${encodeURIComponent(permission)}/`,
  params: { groupId, objectType, objectKey, permission },
  headers,
});

/**
 * `GET /v1/shares/{object_type}/{object_key}/`
 *
 * List of share acls
 *
 * Required roles:
 *  - can_read_acls
 *
 * Responses
 * - 200 - Returns a list of permissions
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AclsSharesACLSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/get_v1_shares__object_type___object_key__}
 */
export const httpGetSharesByObjectTypeByObjectKey = (
  objectType: string,
  objectKey: string,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpGetSharesByObjectTypeByObjectKey,
  method: httpMethod.get,
  url: `/API/acls/v1/shares/${encodeURIComponent(objectType)}/${encodeURIComponent(objectKey)}/`,
  params: { objectType, objectKey },
  headers,
});

export interface AclsHttpPutSharesByShareIdAclByObjectTypeQuery {
  /**
   * Do not trigger search reindexing of the affected objects
   */
  ignore_reindexing?: boolean;
}

/**
 * `PUT /v1/shares/{share_id}/acl/{object_type}/`
 *
 * Create a new acl for multiple share objects
 *
 * Required roles:
 *  - can_write_acls
 *
 * Responses
 * - 200 - Returns the updated objects
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AclsCreateACLsResultSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/put_v1_shares__share_id__acl__object_type__}
 */
export const httpPutSharesByShareIdAclByObjectType = (
  shareId: string,
  objectType: string,
  body: AclsCreateShareACLsSchema,
  query?: AclsHttpPutSharesByShareIdAclByObjectTypeQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpPutSharesByShareIdAclByObjectType,
  method: httpMethod.put,
  url: `/API/acls/v1/shares/${encodeURIComponent(shareId)}/acl/${encodeURIComponent(objectType)}/`,
  params: { shareId, objectType },
  body,
  query,
  headers,
});

export interface AclsHttpDeleteSharesByShareIdAclByObjectTypeByObjectKeyQuery {
  /**
   * Do not trigger search reindexing of the affected objects
   */
  ignore_reindexing?: boolean;
}

/**
 * `DELETE /v1/shares/{share_id}/acl/{object_type}/{object_key}/`
 *
 * Delete a share acl for an object
 *
 * Required roles:
 *  - can_delete_acls
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - ACL does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/delete_v1_shares__share_id__acl__object_type___object_key__}
 */
export const httpDeleteSharesByShareIdAclByObjectTypeByObjectKey = (
  shareId: string,
  objectType: string,
  objectKey: string,
  query?: AclsHttpDeleteSharesByShareIdAclByObjectTypeByObjectKeyQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpDeleteSharesByShareIdAclByObjectTypeByObjectKey,
  method: httpMethod.delete,
  url: `/API/acls/v1/shares/${encodeURIComponent(shareId)}/acl/${encodeURIComponent(objectType)}/${encodeURIComponent(objectKey)}/`,
  params: { shareId, objectType, objectKey },
  query,
  headers,
});

/**
 * `GET /v1/shares/{share_id}/acl/{object_type}/{object_key}/`
 *
 * List of share permissions for an object
 *
 * Required roles:
 *  - can_read_acls
 *
 * Responses
 * - 200 - Returns a list of permissions
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Share doesn't have permissions
 *
 * Response {@link AclsShareACLSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/get_v1_shares__share_id__acl__object_type___object_key__}
 */
export const httpGetSharesByShareIdAclByObjectTypeByObjectKey = (
  shareId: string,
  objectType: string,
  objectKey: string,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpGetSharesByShareIdAclByObjectTypeByObjectKey,
  method: httpMethod.get,
  url: `/API/acls/v1/shares/${encodeURIComponent(shareId)}/acl/${encodeURIComponent(objectType)}/${encodeURIComponent(objectKey)}/`,
  params: { shareId, objectType, objectKey },
  headers,
});

export interface AclsHttpPostSharesByShareIdAclByObjectTypeByObjectKeyQuery {
  /**
   * Do not trigger search reindexing of the affected objects
   */
  ignore_reindexing?: boolean;
}

/**
 * `POST /v1/shares/{share_id}/acl/{object_type}/{object_key}/`
 *
 * Create a new share acl for an object
 *
 * Required roles:
 *  - can_write_acls
 *
 * Responses
 * - 201 - Returns a created acl
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AclsShareACLSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/post_v1_shares__share_id__acl__object_type___object_key__}
 */
export const httpPostSharesByShareIdAclByObjectTypeByObjectKey = (
  shareId: string,
  objectType: string,
  objectKey: string,
  body: AclsShareACLSchema,
  query?: AclsHttpPostSharesByShareIdAclByObjectTypeByObjectKeyQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpPostSharesByShareIdAclByObjectTypeByObjectKey,
  method: httpMethod.post,
  url: `/API/acls/v1/shares/${encodeURIComponent(shareId)}/acl/${encodeURIComponent(objectType)}/${encodeURIComponent(objectKey)}/`,
  params: { shareId, objectType, objectKey },
  body,
  query,
  headers,
});

export interface AclsHttpPutSharesByShareIdAclByObjectTypeByObjectKeyQuery {
  /**
   * Do not trigger search reindexing of the affected objects
   */
  ignore_reindexing?: boolean;
}

/**
 * `PUT /v1/shares/{share_id}/acl/{object_type}/{object_key}/`
 *
 * Update share acl for an object
 *
 * Required roles:
 *  - can_write_acls
 *
 * Responses
 * - 200 - Returns an updated acl
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - ACL does not exist
 *
 * Response {@link AclsShareACLSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/put_v1_shares__share_id__acl__object_type___object_key__}
 */
export const httpPutSharesByShareIdAclByObjectTypeByObjectKey = (
  shareId: string,
  objectType: string,
  objectKey: string,
  body: AclsShareACLSchema,
  query?: AclsHttpPutSharesByShareIdAclByObjectTypeByObjectKeyQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpPutSharesByShareIdAclByObjectTypeByObjectKey,
  method: httpMethod.put,
  url: `/API/acls/v1/shares/${encodeURIComponent(shareId)}/acl/${encodeURIComponent(objectType)}/${encodeURIComponent(objectKey)}/`,
  params: { shareId, objectType, objectKey },
  body,
  query,
  headers,
});

/**
 * `GET /v1/shares/{share_id}/acl/{object_type}/{object_key}/{permission}/`
 *
 * Check if a share has a particular permission for an object
 *
 * Required roles:
 *  - can_read_acls
 *
 * Responses
 * - 200 - Returns an empty JSON object
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - User does not have permission
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/get_v1_shares__share_id__acl__object_type___object_key___permission__}
 */
export const httpGetSharesByShareIdAclByObjectTypeByObjectKeyByPermission = (
  shareId: string,
  objectType: string,
  objectKey: string,
  permission: string,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpGetSharesByShareIdAclByObjectTypeByObjectKeyByPermission,
  method: httpMethod.get,
  url: `/API/acls/v1/shares/${encodeURIComponent(shareId)}/acl/${encodeURIComponent(objectType)}/${encodeURIComponent(objectKey)}/${encodeURIComponent(permission)}/`,
  params: { shareId, objectType, objectKey, permission },
  headers,
});

export interface AclsHttpDeleteUsersByUserIdAclByObjectTypeByObjectKeyQuery {
  /**
   * Do not trigger search reindexing of the affected objects
   */
  ignore_reindexing?: boolean;
}

/**
 * `DELETE /v1/users/{user_id}/acl/{object_type}/{object_key}/`
 *
 * Delete a user acl for an object
 *
 * Required roles:
 *  - can_delete_acls
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - ACL does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/delete_v1_users__user_id__acl__object_type___object_key__}
 */
export const httpDeleteUsersByUserIdAclByObjectTypeByObjectKey = (
  userId: string,
  objectType: string,
  objectKey: string,
  query?: AclsHttpDeleteUsersByUserIdAclByObjectTypeByObjectKeyQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpDeleteUsersByUserIdAclByObjectTypeByObjectKey,
  method: httpMethod.delete,
  url: `/API/acls/v1/users/${encodeURIComponent(userId)}/acl/${encodeURIComponent(objectType)}/${encodeURIComponent(objectKey)}/`,
  params: { userId, objectType, objectKey },
  query,
  headers,
});

/**
 * `GET /v1/users/{user_id}/acl/{object_type}/{object_key}/`
 *
 * List of user permissions for an object
 *
 * Required roles:
 *  - can_read_acls
 *
 * Responses
 * - 200 - Returns a list of permissions
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - User doesn't have permissions
 *
 * Response {@link AclsUserACLSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/get_v1_users__user_id__acl__object_type___object_key__}
 */
export const httpGetUsersByUserIdAclByObjectTypeByObjectKey = (
  userId: string,
  objectType: string,
  objectKey: string,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpGetUsersByUserIdAclByObjectTypeByObjectKey,
  method: httpMethod.get,
  url: `/API/acls/v1/users/${encodeURIComponent(userId)}/acl/${encodeURIComponent(objectType)}/${encodeURIComponent(objectKey)}/`,
  params: { userId, objectType, objectKey },
  headers,
});

export interface AclsHttpPutUsersByUserIdAclByObjectTypeByObjectKeyQuery {
  /**
   * Do not trigger search reindexing of the affected objects
   */
  ignore_reindexing?: boolean;
}

/**
 * `PUT /v1/users/{user_id}/acl/{object_type}/{object_key}/`
 *
 * Update or create user acl for an object
 *
 * Required roles:
 *  - can_write_acls
 *
 * Responses
 * - 200 - Returns an updated acl
 * - 201 - Returns a created acl
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - ACL does not exist
 *
 * Response {@link AclsUserACLSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/put_v1_users__user_id__acl__object_type___object_key__}
 */
export const httpPutUsersByUserIdAclByObjectTypeByObjectKey = (
  userId: string,
  objectType: string,
  objectKey: string,
  body: AclsUserACLSchema,
  query?: AclsHttpPutUsersByUserIdAclByObjectTypeByObjectKeyQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpPutUsersByUserIdAclByObjectTypeByObjectKey,
  method: httpMethod.put,
  url: `/API/acls/v1/users/${encodeURIComponent(userId)}/acl/${encodeURIComponent(objectType)}/${encodeURIComponent(objectKey)}/`,
  params: { userId, objectType, objectKey },
  body,
  query,
  headers,
});

/**
 * `GET /v1/users/{user_id}/acl/{object_type}/{object_key}/{permission}/`
 *
 * Check if a user has a particular permission for an object
 *
 * Required roles:
 *  - can_read_acls
 *
 * Responses
 * - 200 - Returns an empty JSON object
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - User does not have permission
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/acls/spec/#/default/get_v1_users__user_id__acl__object_type___object_key___permission__}
 */
export const httpGetUsersByUserIdAclByObjectTypeByObjectKeyByPermission = (
  userId: string,
  objectType: string,
  objectKey: string,
  permission: string,
  headers?: IconikApiHeaders,
) => ({
  id: AclsHttpGetUsersByUserIdAclByObjectTypeByObjectKeyByPermission,
  method: httpMethod.get,
  url: `/API/acls/v1/users/${encodeURIComponent(userId)}/acl/${encodeURIComponent(objectType)}/${encodeURIComponent(objectKey)}/${encodeURIComponent(permission)}/`,
  params: { userId, objectType, objectKey, permission },
  headers,
});
